import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';
import sKey from '../../SoundAssetKeys';
import { customConvertToButton } from '../inGame/menuUI';
import { textIn } from '../inGame/tweenTimelines';
import { createChooseShape } from './chooseShape';
//import { createChooseShape } from './chooseShape';
import { nextBut, backBut, toggleNext } from './nextBackHandler';

export function makeDonutStart(scene)
{
    
    scene.nextBut = ABCya.Images.addImage(892, 405, "Make Your Donut/Btn_Next",scene).setScale(0);
    scene.backBut = ABCya.Images.addImage(118, 405, "Make Your Donut/Btn_Previous",scene).setScale(0);
    scene.nextBut.setInteractive();
    scene.backBut.setInteractive();

    // customConvertToButton(scene.nextBut);
    // customConvertToButton(scene.backBut);

    toggleNext(scene);

    scene.nextBut.on("pointerdown",()=>{
        simpleClickAnimation(scene.nextBut,true,false);
        gameData.makeData.index++;
        nextBut(scene);
    });

    scene.backBut.on("pointerdown",()=>{
        simpleClickAnimation(scene.backBut,true,false);
        gameData.makeData.index--;
        backBut(scene);
    });

    //scene.questionText.setPosition(512,368);
    scene.questionText.y = 398;
    scene.questionText.text = "Great Job!\n\nHungry?\nLet's make a donut!";
    
    //ABCya.Tweens.addTween(scene.questionText,500,{alpha:{start:0,to:1},x:{start:"-=1300",to:scene.questionText.x}},Phaser.Math.Easing.Quadratic.Out);
    
    ABCya.Tweens.addTween(scene.questionText,700,{x:{start:-1000, to: 512}},Phaser.Math.Easing.Quadratic.InOut,()=>{
        scene.custSound.playSoundCustom(sKey._great_job);
        setTimeout(()=>{
            if(gameData.makeData.index === 0)
            {
                scene.custSound.playSoundCustom(sKey._hungry_make_donut);
            }
        },2040);
     
    });
}

export function simpleClickAnimation(clicked,tintButton = true, toggleInteractive = true)
{
    const scene = clicked.scene;
    scene.custSound.playSoundCustom(sKey._click_select_donuts);
    const tween = ABCya.Tweens.addTween(clicked,150,{scale:.9,yoyo:true});

    if(tintButton)
    {
        tween.on('start',()=>{
            clicked.setTint(0xFFFFFF)
        });
        tween.on('complete',()=>{
            clicked.clearTint();
        });
    }

    if(toggleInteractive)
    {
        tween.on('start',()=>{
            clicked.disableInteractive();
        });
        tween.on('complete',()=>{
            clicked.setInteractive();
        });
    }
}